import { VALIDATE_SIZE_MESSAGE } from '@/common/driveserver';
import { isValidFileSize } from '@/utils/validations';
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations(['showmsg']),

    showInvalidFiles(invalidFiles) {
      const fileNames = invalidFiles.join('<br>');

      const message = `
        ${VALIDATE_SIZE_MESSAGE}
        <br>
        <br>
        ${fileNames}
      `;

      this.showmsg({ text: message });
    },

    showServiceInvalidErrors(invalidFiles) {
      const messageTitle = 'Atenção! O upload falhou para os seguintes arquivos:';
      const messageBody = '';

      invalidFiles.forEach((file) => {
        messageBody.push(
          `Arquivo: ${file.name} - Causa: ${file.error.message}<br>`,
        );
      });

      const message = `
        ${messageTitle}
        <br>
        <br>
        ${messageBody}
      `;

      this.showmsg({ text: message });
    },

    validateBase64FilesSize(files) {
      const filesBody = files.map((file) => file.body);

      let noInvalidFiles = false;

      filesBody.forEach((fileBody) => {
        if (isValidFileSize(fileBody)) {
          noInvalidFiles = true;
        }
      });

      return noInvalidFiles;
    },
  },
};
